<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;

  .gy-html {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    border: none !important;
  }

  .gy-html /deep/ table {
    border-collapse: collapse;
    border-color: rgb(232, 232, 232);
  }

  .gy-html /deep/ table tbody tr:first-child {
    height: 26px;
    font-size: 12px;
    background: rgb(123, 127, 128);
  }

  .gy-html /deep/ table tbody tr:not(:first-child) {
    height: 26px;
    font-size: 12px;
    color: #606672;
  }

  .tj-html {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    border: none !important;
  }

  .tj-html /deep/ table {
    border-collapse: collapse;
    border-color: rgb(232, 232, 232);
  }

  .tj-html /deep/ table tbody tr:first-child {
    height: 26px;
    font-size: 12px;
    background: rgb(123, 127, 128);
  }

  .tj-html /deep/ table tbody tr:not(:first-child) {
    height: 26px;
    font-size: 12px;
    color: #606672;
  }
}

.left {
  display: flex;
  align-items: center;

  .icon {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: #419fff;
  }

  .txt {
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
    color: #303133;
    margin-left: 12px;
  }
}

.content-box {
  display: flex;
  justify-content: space-between;
  color: #f56c6c;
  margin-top: 20px;
  font-size: 14px;

  .box1 {
    align-self: flex-start;
  }

  .box2 {
    align-self: flex-end;
    color: #e6a23c;
  }
}
</style>

<template>
  <div style="display: inline;" >
<!--    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt" getKey="rows" > </yi_curd_table>-->
    <div class="container">
      <div class="form" v-loading="dialogLoading">
        <div>
          <el-form size="mini" :model="conditions" :inline="true" >
            <el-form-item :label="$t('shebeimingcheng')" required>
              <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="conditions.equipmentId"  :disabled="true"> </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('mujumingcheng')">
              <yi_data_select ref="mould" :multiple="false" type="mould" :ids.sync="conditions.mouldId" :disabled="true">  </yi_data_select>
<!--              <yi_cross_select :max="1" :component="'web_base_mould_list'" :ids.sync="conditions.mouldId" :disabled="true"> </yi_cross_select>-->
            </el-form-item>
            <el-form-item :label="$t('beizhu')"  >
              <el-input v-model="conditions.remark" :disabled="true"></el-input>
            </el-form-item>
            <el-button type="primary" size="mini" @click="distribute" v-if="this.pointConfigList&&this.pointConfigList.length>0&& this.isSend" :loading="loading">{{ $t('quedingxiafa') }}</el-button>
            <div style="display: flex;justify-content: space-between">
              <div class="left" >
                <span class="icon"></span>
                <span class="txt">{{ $t('shishicanshu') }}</span>
              </div>
              <div class="right" style="display:inline-flex">
                <span  @click="switchView" class="yicon yicon-list_check">  {{$t('qiehuanshitu')}}</span>
              </div>
            </div>
          </el-form>

        </div>
        <div>
          <div v-if="pointConfigList&&pointConfigList.length">
            <div  style="color: #606266;margin-top: 8px;">
              <!--操作模式-->
              <div  style="float: left">
                {{ $t('zhuangtai') }}:
                <span style="margin-left: 10px;color: #0000cc" v-if="state = pointConfigMap['CurrentState']" >
                  <span v-if="state.afterValueToUnit && parseInt( state.afterValueToUnit) >= 0">{{ $t('zaixian') }}</span>
                  <span v-else>{{ $t('lixian') }}</span>
                </span>
              </div>
              <div  style="margin-left: 100px;">
                {{ $t('caozuomoshi') }}:
                <span style="margin-left: 10px;color: #0000cc" v-if="manualMode = pointConfigMap['ManualMode']" >
                  <span v-if="manualMode.afterValueToUnit && parseInt( manualMode.afterValueToUnit) == 1">{{ $t('shoudongmoshi') }}</span>
                  <span v-if="manualMode.afterValueToUnit && parseInt( manualMode.afterValueToUnit) == 0">{{ $t('feishoudongmoshi') }}</span>
                </span>
              </div>
            </div>

            <template v-if="showView">
              <!--选中的点和可编辑颜色提示-->
              <div class="content-box">

<!--                <div class="box2"><i class="el-icon-question"></i>{{ $t('biaogeyansebiaozhu') }}</div>-->
              </div>
              <div ref="myElement" class="gy-html" v-html="gy" ></div>
              <br/>
            </template>
            <template v-else>

              <el-row>
                <el-col :span="24">
                  <el-tabs >
                    <el-tab-pane v-for="sub in gyTable" :key="sub.dict" :label="$t(store.state.dictJson['EQUIPMENT_CRAFT_CLASSIFICATION'][sub.dict])" >
                      <el-table stripe  :row-style="{height:42+'px'}" :cell-style="{padding:0+'px'}"
                                :header-cell-style="{background:'#F5F7FA',color:'#606266','font-weight':'700', height:'48px', padding:'0px'}"
                                :data="sub.data" size="mini" style="width:100%" border >
                        <el-table-column align="center" :label="$t('canshumiaoshu')">
                          <template slot-scope="scope" v-if="pointConfigMap[scope.row.code]">
                            <span>{{ $t(pointConfigMap[scope.row.code].pointI18n) }}</span>
                            <span v-if="pointConfigMap[scope.row.code].unit">/{{ pointConfigMap[scope.row.code].unit }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column  :label="$t('zhi')" align="center" >
                          <template slot-scope="scope" v-if="pointConfigMap[scope.row.code]" >
                            <span >{{pointConfigMap[scope.row.code].beforeValueToUnit }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column  :label="$t('xiugaizhi')" align="center" >
                          <template slot-scope="scope"  >
                          <span style="display: none;"> {{tempPoint = points[scope.row.code]}}</span>
                          <div v-if="tempConfig = pointConfigMap[scope.row.code]">
                            <div  :style="{background:tempConfig.modifiable?'#FFE9C9':null,color:getFontColor(tempConfig)}">
                              <span v-if="tempPoint.dictTypeCode"> {{$t(store.state.dictJson[tempPoint.dictTypeCode][tempConfig.afterValueToUnit])}}  </span>
                              <span v-else> {{tempConfig.afterValueToUnit}}</span>
                            </div>
                          </div>
                          </template>
                        </el-table-column>
                        <el-table-column  :label="$t('craft_threshold_configuration_lower_set')" align="center">
                          <template slot-scope="scope" v-if="pointConfigMap[scope.row.code]">
                            <span>{{ pointConfigMap[scope.row.code].lowerLimitValue}}</span>
                          </template>
                        </el-table-column>

                        <el-table-column  :label="$t('craft_threshold_configuration_upper_set')" align="center">
                          <template slot-scope="scope" v-if="pointConfigMap[scope.row.code]">
                            <span>{{ pointConfigMap[scope.row.code].upperLimitValue }}</span>
                          </template>
                        </el-table-column>

                      </el-table>
                      <br/>
                    </el-tab-pane>
                  </el-tabs>
                </el-col>
              </el-row>
            </template>
          </div>
          <div v-else style="margin-top: 220px">
            <el-empty :image-size="80" :description="$t('qingzaisousuolanxuanzeshebeihemujumingcheng')"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
const Base64 = require('js-base64').Base64;
export default {
  name: 'web_process_distribution_adjusting_record_see',
  components: {},
  data() {
    return {
      loading: false,
      base64: Base64,
      conditions: {},
      gyHtml: '',
      msgCode: '', //下发点提示
      showView:true, //视图类型：单页面显示，false ：分组tab显示
      gyTable:[], //showView 为false显示模式
      //设备标准点表：
      points:{},
      //设备点表配置list
      pointConfigList:[],
      //设备点表配置map，通过上面list转{code：point},不能更改，否则gy会重新渲染
      pointConfigMap:{},
      pointConfigMapFix:{},
      //当前可编辑点表
      currentEditPoint:null,
      dialogLoading:false,
      //点值
      pointValues:{},
      row:{},
    };
  },
  props: {
    isSend: {
      type: [Boolean],
      default:false
    },
    id: {
      type: [Number],
      required: true
    },
    formLabelWidth: {
      type: [String]
    },
  },
  computed: {
    gy() {
      try {
        let str = this.base64.decode(this.gyHtml);
        if(!str){
          return ;
        }
        let reg1 = /\[[^\]]*\]/g;
        str.match(reg1).map(code => {
          let c = code.replace('[', '').replace(']', '');
          str = str.replace(code, this.$t(c));
        });

        let reg2 = /\{[^\}]*\}/g;
        str.match(reg2).map(code => {
          let c = code.replace('{', '').replace('}', '');
          if (!this.points[c]) {
            return;
          }
          let value = this.pointValues[c]?this.pointValues[c]:"";

          if (this.points[c].dictTypeCode != null) {
            str = str.replace(code, this.$t(this.store.state.dictJsonAll[this.points[c].dictTypeCode][parseInt(value)]));
          } else {
            /*let prec = this.points[c].dataType !=2 ? null: this.points[c].prec==null?2 : this.points[c].prec;
            if(prec ==null){*/
              str = str.replace(code, value);
           /* }else{
              str = str.replace(code, isNaN(Number(value)) ? '' : Number(value).toFixed(prec == null ? 2 : prec));
            }*/
          }
        });
        this.$nextTick(() => {
          this.fetchHtml();
        });
        return str;
      } catch (error) {
        console.error(error);
      }
    }
  },
  created() {
    this.getPointParamterConfigById();
  },
  mounted() {

  },
  methods: {

    //确定下发
    distribute() {
      this.loading = true;
      this.http.post('/web/craft/adjusting/record/send', {id:this.id}).then(res => {
        this.utils.successMessage(this.$t('craft_sending'));
        this.$emit('dialogClose')
        this.loading = false;
      }).catch(msg => {
        this.utils.errorMessage(this.$t(msg));
        this.loading = false;
      });
    },

    fetchHtml() {
      this.$nextTick(() => {
        let tables = document.getElementsByClassName('gy-html')[0].getElementsByTagName('table');
        for (var i = 0; i < tables.length; i++) {
          let trs = tables[i].getElementsByTagName('tr');
          for (var j = 0; j < trs.length; j++) {
            let tds = trs[j].getElementsByTagName('td');
            for (var k = 0; k < tds.length; k++) {
              const code = tds[k].getAttribute('code');
              const configPoint = this.pointConfigMap[code]
              if(configPoint ){
                if( configPoint.modifiable){
                  tds[k].style.backgroundColor = '#FFE9C9'; //给可编辑点加背景颜色
                }
                tds[k].style.color = this.getFontColor(configPoint);
              }
            }
          }
        }
      })

    },
    getFontColor(configPoint){
      if(configPoint && configPoint.enableSend){
        if(configPoint.upperLimitValue < configPoint.afterValueToUnit){
          return '#F56C6C';
        } else if(configPoint.lowerLimitValue > configPoint.afterValueToUnit){
          return '#F56C6C';
        }else if(parseFloat(configPoint.afterValueToUnit) !== parseFloat(configPoint.beforeValueToUnit)){
          return '#81d2f7';
        }else{
          return '#606266';
        }
      }
      return '#606266';
    },
    //搜索
    async search() {
      this.points =  this.store.state.eqPoints[this.row.equipmentId];
      if (!this.points || this.points.length ==0) {
        this.utils.errorMessage(this.$t('shujvweijiazaiwan'));
        return;
      }
      this.dialogLoading = true;
      this.$nextTick(() => {
        let params = {
          equipmentId: this.row.equipmentId,
          mouldId: this.row.mouldId
        };
        return this.http.get('/web/config/craft/template/monitor/tab?' + this.qs.stringify(params))
          .then(async response => {
            if (response.data.tab === undefined || response.data.tab === null) {
              this.$message.error(this.$t('qingpeizhimuban'));
            } else {
              this.gyHtml = response.data.tab.gy;
              try {
                this.gyTable = JSON.parse(response.data.group).filter(obj=>obj.dict != '32')
              }catch (e) {
                console.log(e)
                this.$message.error(this.$t('craft_craft_template_format_fail'));
              }
            }
            this.dialogLoading = false;
          }).catch(msg => {
            this.utils.errorMessage(this.$t(msg));
            this.dialogLoading = false;
          });
      });
    },

    //获取点配置及实时数据
    async getPointParamterConfigById() {
      this.dialogLoading = true;
      let response = await this.http.get('/web/craft/adjusting/record/listPointParamterConfigById' ,{ params: {
          id:this.id
        }});
      this.row = response.data.record;
      this.conditions.equipmentId = this.row.equipmentId;
      this.conditions.mouldId = this.row.mouldId;
      this.pointConfigList = response.data.list;
      let temMap = {};
      this.pointConfigList.forEach(obj=>{
        this.pointConfigMap[obj.pointCode] = obj;
        temMap[obj.pointCode] = obj.afterValueToUnit;
      });
      this.pointValues = temMap;
      await this.search();
    },

    switchView(){
      this.showView = ! this.showView;
      if(this.showView){
        let temMap = {};
        this.pointConfigList.forEach(obj=>{
          this.pointConfigMap[obj.pointCode] = obj;
          temMap[obj.pointCode] = obj.afterValueToUnit;
        });
        this.pointValues = temMap;
      }

    },
  }
};
</script>
